<template>
  <div class="mb-12">
    <div class="flex flex-col md:flex-row">
    <div class="w-full md:w-1/2 mr-0 md:mr-10">
      <OrganizationCard :has-completed="user.action_flags.has_edited_org_basic" :organization="organization" />
    </div>
    <hr class="w-px bg-n-gray border border-n-gray w-full block md:hidden mt-12 mb-12" />
    <div class="w-full md:w-1/2 ml-0 md:ml-10">
      <OrganizationReimagine :has-completed="user.action_flags.has_edited_org_reimagine" :organization="organization" />
    </div>
  </div>
    <hr class="w-px bg-n-gray border border-n-gray w-full mt-12 mb-12" />
    <OrganizationStory :has-completed="user.action_flags.has_edited_org_story" :organization="organization" />
  </div>
</template>

<script>
import OrganizationCard from "./organization/OrganizationCard.vue";
import { mapGetters } from "vuex";
import OrganizationReimagine from "./organization/OrganizationReimagine.vue";
import OrganizationStory from "./organization/OrganizationStory.vue";
export default {
  name: "OrganizationProfileHome",
  components: {OrganizationStory, OrganizationReimagine, OrganizationCard },
  computed: {
    ...mapGetters({ user: 'user', organization: "organization", }),
  },
  mounted() {
    this.$store.dispatch("getOrganization", { id: this.user.organization_id });
  }
}
</script>

<style scoped>

</style>